<template>
    <bread-crumb :vector="[{fa : props.storeDetail.categoryFa,path : `/Shops/${props.storeDetail.category}`},{fa : `فروشگاه ${props.storeDetail.name}`,path : `/Store/${props.storeDetail.id}`}]" v-if="props.storeDetail.id"/>
        <div class="bg-white position-relative mt-2 mx-2">
            <img class="w-100 " style="height:10em;border-radius: 3px;filter: brightness(0.3);" :src="'https://radap.ir/'+props.storeDetail.store_img1"/>
            <div class="d-flex align-items-center justify-content-between py-1 position-absolute w-100" style="top:5px">
                <h6 class="px-2 py-1 ms-2 text-light rounded" style="font-weight: 700">فروشگاه {{props.storeDetail.name}}</h6>
                <button class="btn btn-light text-success py-0 px-1 me-2" style="font-size: 11px;" @click="getSupplierInformation">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="#000" d="M12 17a.97.97 0 0 0 .713-.288A.97.97 0 0 0 13 16v-4.025a.93.93 0 0 0-.287-.7A1 1 0 0 0 12 11a.97.97 0 0 0-.712.287A.97.97 0 0 0 11 12v4.025q0 .425.288.7A1 1 0 0 0 12 17m0-8a.97.97 0 0 0 .713-.288A.97.97 0 0 0 13 8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.712.287A.97.97 0 0 0 11 8q0 .424.288.712A.97.97 0 0 0 12 9m0 13a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.325 0 5.663-2.337T20 12c0-3.325-.779-4.104-2.337-5.663Q15.325 4 12 4c-3.325 0-4.104.779-5.662 2.337Q4 8.675 4 12c0 3.325.78 4.104 2.338 5.663Q8.675 20 12 20"></path></svg>
                    اطلاعات و نظرات
                </button>
            </div>
    
            <div class="d-flex justify-content-around w-100 position-absolute" style="bottom:5px" >
                <div class="sc-dkPtyc Header__CardInformation-sc-18biwoj-5 jZPlKa cHslMM">
                    <svg width="1.125rem" height="1.125rem" viewBox="0 0 18 18" fill="#FFF">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99984 0.666016C13.6022 0.666016 17.3332 4.39698 17.3332 8.99935C17.3332 13.6017 13.6022 17.3327 8.99984 17.3327C4.39746 17.3327 0.666504 13.6017 0.666504 8.99935C0.666504 4.39698 4.39746 0.666016 8.99984 0.666016ZM8.99984 2.33268C5.31794 2.33268 2.33317 5.31745 2.33317 8.99935C2.33317 12.6812 5.31794 15.666 8.99984 15.666C12.6817 15.666 15.6665 12.6812 15.6665 8.99935C15.6665 5.31745 12.6817 2.33268 8.99984 2.33268ZM8.99984 3.99935C9.4272 3.99935 9.77943 4.32105 9.82756 4.7355L9.83317 4.83268V8.72935L11.9197 9.9462C12.2889 10.1615 12.431 10.6169 12.2638 10.9991L12.2197 11.0859C12.0043 11.4551 11.549 11.5972 11.1667 11.43L11.0799 11.3858L8.57995 9.9275C8.35238 9.79475 8.2027 9.56344 8.17225 9.30551L8.1665 9.20768V4.83268C8.1665 4.37245 8.5396 3.99935 8.99984 3.99935Z"></path>
                    </svg>
                    <p class="sc-hKwCoD jvsOGS">زمان ارسال</p>
                    <p class="sc-hKwCoD jGSjbR">
                    <span class="sc-hKwCoD SEoNM"></span>
                    تا {{convertToPersian(String(props.storeDetail.track_time))}} دقیقه
                    </p>
                </div>
                <div class="d-flex align-items-center flex-column">
                    <svg width="1.25rem" height="1.25rem" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5832 9.58325C14.1229 9.58325 13.7498 9.95635 13.7498 10.4166C13.7498 10.8768 14.1229 11.2499 14.5832 11.2499C15.0434 11.2499 15.4165 10.8768 15.4165 10.4166C15.4165 9.95635 15.0434 9.58325 14.5832 9.58325Z"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.55167 17.6256C5.58545 18.4597 3.42815 17.2569 2.99477 15.2849L2.80188 15.3599C2.54548 15.4596 2.25639 15.4264 2.02933 15.2711C1.80228 15.1157 1.6665 14.8584 1.6665 14.5833L1.6665 9.16659C1.6665 6.62223 2.7184 4.66703 4.31719 3.36431C5.89569 2.07812 7.96582 1.45825 9.99984 1.45825C12.0339 1.45825 14.104 2.07812 15.6825 3.36431C17.2813 4.66703 18.3332 6.62223 18.3332 9.16659V12.4999C18.3332 12.8344 18.1332 13.1364 17.8253 13.2671L7.55167 17.6256ZM9.90247 7.08896L3.45858 7.84706C3.73253 6.47175 4.43547 5.41782 5.36998 4.65636C6.60398 3.65088 8.28385 3.12492 9.99984 3.12492C11.7158 3.12492 13.3957 3.65088 14.6297 4.65636C15.8434 5.64531 16.6665 7.12761 16.6665 9.16659V11.9482L6.90075 16.0913C5.83543 16.5432 4.65792 15.7992 4.58658 14.6659L10.3019 12.4433C10.6222 12.3187 10.8332 12.0103 10.8332 11.6666V7.91659C10.8332 7.67861 10.7314 7.45199 10.5536 7.29386C10.3758 7.13572 10.1388 7.06115 9.90247 7.08896ZM9.1665 11.0965L3.33317 13.365L3.33317 9.53998L9.1665 8.85371L9.1665 11.0965Z"></path>
                    </svg>
                    <p class="sc-hKwCoD jvsOGS">هزینه ارسال</p>
                    <div class="sc-dkPtyc haKYkj">
                        <div class="sc-dkPtyc gsAfZm">
                            <div class="sc-dkPtyc iDOvlP"> 
                                <span class="sc-hKwCoD iNbUWE" v-if="props.storeDetail.delivery_cost != 0">
                                    {{convertToPersian(String(props.storeDetail.delivery_cost))}} تومان
                                </span>
                                <span class="sc-hKwCoD iNbUWE" style="color:#c1ff0c" v-else>رایگان !</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-column">
                    <svg width="1.1875rem" height="1.1875rem" viewBox="0 0 19 19" fill="#fff">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1668 0.0410156C11.5205 0.0410156 9.37516 2.18632 9.37516 4.83268C9.37516 7.47905 11.5205 9.62435 14.1668 9.62435C16.8132 9.62435 18.9585 7.47905 18.9585 4.83268C18.9585 2.18632 16.8132 0.0410156 14.1668 0.0410156ZM10.6252 4.83268C10.6252 2.87667 12.2108 1.29102 14.1668 1.29102C16.1228 1.29102 17.7085 2.87667 17.7085 4.83268C17.7085 6.78869 16.1228 8.37435 14.1668 8.37435C12.2108 8.37435 10.6252 6.78869 10.6252 4.83268Z"></path>
                        <path d="M8.39257 3.99935C8.35364 4.27152 8.3335 4.54975 8.3335 4.83268C8.3335 5.11562 8.35364 5.39385 8.39257 5.66602H6.00307L7.21753 10.8287C7.29617 11.2246 7.64727 11.5072 8.06683 11.4993L14.5161 11.4995C14.9197 11.5072 15.2708 11.2246 15.3524 10.8147L15.4135 10.5325C16.0884 10.3856 16.7197 10.1218 17.2852 9.76346L16.9842 11.1534C16.7483 12.3412 15.695 13.1891 14.5002 13.166L8.0828 13.1659C6.87203 13.1891 5.81872 12.3412 5.58898 11.1819L3.50682 2.33268H1.66683C1.20659 2.33268 0.833496 1.95959 0.833496 1.49935C0.833496 1.03911 1.20659 0.666016 1.66683 0.666016H4.16683C4.55354 0.666016 4.88944 0.932053 4.97801 1.30848L5.61101 3.99935H8.39257Z"></path>
                        <path d="M6.66683 16.4993C6.66683 17.4198 7.41302 18.166 8.3335 18.166C9.25397 18.166 10.0002 17.4198 10.0002 16.4993C10.0002 15.5789 9.25397 14.8327 8.3335 14.8327C7.41302 14.8327 6.66683 15.5789 6.66683 16.4993Z"></path>
                        <path d="M12.5002 16.4993C12.5002 17.4198 13.2464 18.166 14.1668 18.166C15.0873 18.166 15.8335 17.4198 15.8335 16.4993C15.8335 15.5789 15.0873 14.8327 14.1668 14.8327C13.2464 14.8327 12.5002 15.5789 12.5002 16.4993Z"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4585 3.37435C16.7026 3.61843 16.7026 4.01415 16.4585 4.25823L14.1668 6.5499C13.9228 6.79398 13.527 6.79398 13.2829 6.5499L12.2413 5.50823C11.9972 5.26415 11.9972 4.86843 12.2413 4.62435C12.4854 4.38027 12.8811 4.38027 13.1252 4.62435L13.7249 5.22407L15.5746 3.37435C15.8187 3.13027 16.2144 3.13027 16.4585 3.37435Z"></path>
                    </svg>
                    <p class="sc-hKwCoD jvsOGS">حداقل خرید</p>
                    <div class="sc-dkPtyc haKYkj">
                        <div class="sc-dkPtyc gsAfZm">
                            <div class="sc-dkPtyc iDOvlP"><span class="sc-hKwCoD iNbUWE"> {{convertToPersian(numberFormat(String(props.storeDetail.min_sale)))}} تومان</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="props.storeDetail.secret == 1" class="alert alert-warning mt-4 text-center rounded-0" style="font-size: 14px;font-weight: 900;text-shadow: 1px 1px 2px #ffd4d4;box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;">تمام سفارشات از این فروشگاه در بسته بندی کاملا محرمانه و بدون درج محتوی و نام فروشگاه ارسال میشود.</div>
</template>

<script setup>
import { convertToPersian, numberFormat } from '@/composables/digits';
import BreadCrumb from '../../item/BreadCrumb.vue'
import { defineProps } from 'vue'
import { useRoute,useRouter } from 'vue-router';
let route = useRoute()
let router = useRouter()
let props = defineProps(['storeDetail'])

function getSupplierInformation(){
    router.push({name:'StoreInformation',params:{id:route.params.id}})
}
</script>
<style scoped>
.MuiSvgIcon-root{
    fill: currentColor;
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    flex-shrink: 0;
    user-select: none;
}
.h5 {
    color: #0c0c0c;
    text-transform: uppercase;
    font-size: 1.5em;
    font-weight: 700;
    letter-spacing: 1px;
}
.container-fluid{
    --bs-gutter-x: 0 !important;
}
.head-shop{
    height: 10em;
    background-size: 100%;
    background-repeat: round;
    filter: brightness(.2);
    position: relative;
    border-radius : 5px;
}
.brand-shop-img{
    min-width: 2.2em;
    min-height: 2.2em;
    max-width: 2.2em;
    max-height: 2.2em;
    border-radius: 50px;
    background-size: cover;
    margin: 1.5rem;
    margin-left: .5rem;
}
.brand-shop{
    color: white;
    font-size: 1.1em;
    font-weight: 600;
}


@media (max-width:300px){
    .div-shop{
        flex-direction: column;
    }
    .div-detail{
        display: flex;
        justify-content: space-between;
    }
    .head-shop{
        height:15em;
    }
}
.kXauzU{
    text-align: center;
}
.gntEHZ{
    margin-left: 2px;
    margin-right: 2px;
    padding: 10px;
    background-color: whitesmoke;
    border-radius: 5px;
    padding-top: .25em;
    padding-bottom: .25em;
    /* border-left:1px dashed black; */
}
p {
    letter-spacing: 0 !important;
    margin-bottom:0 !important
}
.kWLTrr {
    background: rgb(255, 255, 255);
    /* box-shadow: rgb(0 0 0 / 8%) 0px 2px 8px, rgb(0 0 0 / 16%) 0px 8px 32px; */
    border-radius: 0.75rem;
    animation: 0.3s cubic-bezier(0.4, 0, 0, 1.5) 0s 1 normal forwards running hPIMuN;
    /* max-height: 90vh; */
    overflow: hidden;
}
.dxUwfN {
    width: 45rem;
}
.kHUHMT {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
    width: 100%;
}
.jJpJAX {
    padding: 1.375rem 1.625rem;
}
.dFpITq {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    align-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
}

.dDLLQr {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
    flex-direction: column;
}
.bWrgAL {
    width: 6rem;
    height: 6rem;
    margin-left: 1.25rem;
    border-radius: 0.75rem;
    box-shadow: rgb(58 61 66 / 6%) 0px 1px 0px, rgb(0 0 0 / 30%) 0px 8px 32px -16px;
}
.gdGGmq {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    align-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}
.coiNLl * {
    margin-bottom: 0.25rem;
}
.iAfsSk {
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 2rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.coiNLl * {
    margin-bottom: 0.25rem;
}
.iVIhbz {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.fxcfxr {
    min-width: 11.5rem;
    height: 8rem;
    overflow: hidden;
    background-color: rgb(235, 237, 240);
    border-radius: 0.5rem;
}
.isZJuw {
    position: relative;
}
.leaflet-container.leaflet-touch-zoom {
    touch-action: pan-x pan-y;
}
.leaflet-container {
    font: 12px/1.5 Helvetica Neue,Arial,Helvetica,sans-serif;
}
.leaflet-container {
    background: #ddd;
    outline: 0;
}
.leaflet-container {
    -webkit-tap-highlight-color: transparent;
}
.leaflet-container {
    overflow: hidden;
}
.ljIkJB {
    margin: 0.5rem 0px;
}
.jLiZhb {
    display: flex;
    justify-content: space-around;
    align-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
}
.jZPlKa {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: column nowrap;
    flex: unset;
    justify-content: space-between;
}
.cHslMM > :nth-child(2) {
    margin: 0;
}
.jvsOGS {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: white;
    text-align: initial;
}

.SEoNM {
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(0, 184, 98);
    text-align: initial;
}
.jZPlKa {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: column nowrap;
    flex: unset;
}
.cHslMM > :nth-child(2) {
    margin: 0;
}

.jZPlKa {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: column nowrap;
    flex: unset;
    justify-content: space-between;
}
.cHslMM > :nth-child(2) {
    margin: 0;
}


.haKYkj {
    display: inline-flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}
.gsAfZm {
    display: inline-flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: row nowrap;
    flex: unset;
}
.iDOvlP {
    display: inline-flex;
    -webkit-box-pack: initial;
    place-content: initial;
    align-items: flex-start;
    flex-flow: column nowrap;
    flex: unset;
}
.iNbUWE {
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: white;
    text-align: initial;
}
.fPgtmC {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(83, 86, 92);
    text-align: initial;
}
.gzfYUv {
    /* height: calc(90vh - 18rem); */
    /* overflow-y: auto; */
}
.dzUbmU {
    height: 6.75rem;
}
.dDLLQr {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
    flex-direction: column;
}
.iAbMiD {
    padding-right: 1.25rem;
    padding-bottom: 1rem;
}

.kkeLkg {
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    align-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}
.iAfsSk {
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 2rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.diqByn {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(166, 170, 173);
    text-align: initial;
}

.gCMoxD {
    padding-bottom: 1rem;
}

.gqbuWv {
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    align-content: initial;
    align-items: flex-end;
    flex-flow: column nowrap;
    flex: unset;
}
.gCMoxD > * {
    -webkit-box-align: center;
    align-items: center;
    margin-top: 0.3125rem;
}

.dDLLQr {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
    flex-direction: column;
}
.dzUbmU {
    height: 6.75rem;
}

.dDLLQr {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
    flex-direction: column;
}
.jHelQN {
    padding: 1rem;
}


.auEpD {
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.5rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(83, 86, 92);
    text-align: initial;
}
.jjoKdG {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: row nowrap;
    flex: unset;
}
.jfOor > :first-child {
    margin-left: 0.625rem;
}
.jGSjbR {
    font-size: 0.75rem;
    line-height: 1rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: white;
    text-align: initial;
}
.liqPWy {
    position: relative;
    background-color: rgba(58, 61, 66, 0.06);
    border-radius: 0.75rem;
    cursor: pointer;
}
.jjoKdG {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: row nowrap;
    flex: unset;
}
.hwaIRe {
    position: absolute;
    width: 50%;
    height: 2.25rem;
    margin-right: 0.125rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.625rem;
    transform: translateX(0px);
    transition: all 0.1s ease 0s;
}
.hwaIRe {
    position: absolute;
    width: 50%;
    height: 2.25rem;
    margin-right: 0.125rem;
    background-color: rgb(255, 255, 255);
    border-radius: 0.625rem;
    transform: translateX(0px);
    transition: all 0.1s ease 0s;
}
.OJaBK {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(0, 184, 98);
    text-align: initial;
}
.iVIhbz {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.kHUHMT {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}
.emirWP > * {
    flex-shrink: 0;
}

.jJiakr {
    box-sizing: border-box;
    padding: .5rem;
    padding-right: 1rem;
    border-bottom: 0.0625rem solid rgba(58, 61, 66, 0.12);
}
.dDLLQr {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
    flex-direction: column;
}
.gGVATn {
    flex-shrink: 0;
    width: 10rem;
    margin-left: 1rem;
}
.kHUHMT {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}

.gGVATn > * {
    margin-top: 0.375rem;
}
.DZqTL {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-wrap: normal;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.gGVATn > * {
    margin-top: 0.375rem;
}
.iVIhbz {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.gGVATn > :last-child {
    width: 2rem;
    padding: 0.125rem 0.375rem;
    text-align: center;
    border: 0.0625rem solid rgb(235, 237, 240);
    border-radius: 0.25rem;
}
.fVKHMA {
    visibility: hidden;
}
.gGVATn > * {
    margin-top: 0.375rem;
}
.iVIhbz {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}

.hTcEtO {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    align-content: initial;
    align-items: flex-start;
    flex-flow: column nowrap;
    flex: unset;
}


.iVIhbz {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
}
.fROWgq {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row wrap;
    flex: unset;
}
.cBKeZu {
    margin-top: .5em;
    padding: 0.5rem;
    border: 0.0625rem solid rgba(58, 61, 66, 0.12);
    border-radius: 0.5rem;
}
.gdGGmq {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    align-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}
.cBKeZu > :first-child {
    margin-bottom: 0.5rem;
}
.hqKCQZ {
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(255, 0, 166);
    text-align: initial;
}

.place-card {
    display: none !important;
}
.ra-btn-outline-warning{
    color:#dbdb21;
    border:1px solid #dbdb21
}
.w-65{
    width: 65%;
}
.f-text-succes{
    color:#22d722
}
</style>